import Modal from 'react-bootstrap/Modal';
import MapGeoSelect from './MapGeoSelect';

export interface MapGeoSelectModalProps {
  showGeoMap: boolean;
  setShowGeoMap: React.Dispatch<React.SetStateAction<boolean>>;
  center: [number, number];
  zoom: number;
  width: string;
  height: string;
  geoPolygon: any;
  setGeoPolygon: React.Dispatch<React.SetStateAction<any>>;
  geoPolygonImage: string;
  setGeoPolygonImage: React.Dispatch<React.SetStateAction<string>>;
};

// modal component for geoploygon map
export default function MapGeoSelectModal(
  {
    showGeoMap,
    setShowGeoMap,
    center,
    zoom,
    width,
    height,
    geoPolygon,
    setGeoPolygon,
    geoPolygonImage,
    setGeoPolygonImage
  }: MapGeoSelectModalProps
) {

  return (
    <>
      <Modal
        show={showGeoMap}
        animation={true}
        fullscreen={true}
        dialogClassName="modal-90w modal-90h"
        onHide={() => {
          setShowGeoMap(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>SigCap Geopolygon Selection</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MapGeoSelect
            showGeoMap={showGeoMap}
            setShowGeoMap={setShowGeoMap}
            center={center}
            zoom={zoom}
            height={height}
            width={width}
            geoPolygon={geoPolygon}
            setGeoPolygon={setGeoPolygon}
            geoPolygonImage={geoPolygonImage}
            setGeoPolygonImage={setGeoPolygonImage}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
